import {Injectable} from '@angular/core';
import {ApiService} from "../api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {plainToClass} from "class-transformer";
import {PromotionDate} from "../../models/promotion/promotion-date";

@Injectable({
    providedIn: 'root'
})
export class PromotionDateService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public getItemsAPI(id: number, params?: string[]): Observable<PromotionDate[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/promotions/${id}/dates`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<PromotionDate[]>(url, {
            headers: headers
        }).pipe(
            map((items: object[]): PromotionDate[] => {

                return items.map((item: object): PromotionDate => {

                    return plainToClass(PromotionDate, item);
                });
            })
        );
    }
}
